import { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls, formatter } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { creditAllocationAPI } from 'api/credit'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  creditAllocationTxFormTypes,
  creditAllocationTxFormSubmitValuesTypes,
  creditAllocationTxFormSubmitActionsTypes,
} from 'types/creditAllocationTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const CREDITALLOCATIONTXINITVAL: creditAllocationTxFormTypes = {
  traderId: 0,
  creditValue: 0,
  externalTransactionId: 0,
  ident: '',
  cashier: '',
  guid: '',
  transactionDate: '',
  storeId: 0,
  comments: '',
  traceNumber: 0,
  reasonId: 0,
  pin: '',
}

export const useCreditAllocationTx = (
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: creditAllocationTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleMerchantSet: (merchant: MerchantLookupTypes[]) => void
  handleSubmitCreditAllocationTx: (
    values: creditAllocationTxFormSubmitValuesTypes,
    actions: creditAllocationTxFormSubmitActionsTypes
  ) => void
  handleClearCreditAllocationTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseTxMerchant, purchaseTxMerchantSet] = useState<
    MerchantLookupTypes[]
  >([])
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] =
    useState<creditAllocationTxFormTypes>({
      ...CREDITALLOCATIONTXINITVAL,
      cashier: authTokenUsername,
      externalTransactionId: formatter.externalIdentification(),
      ident: String(member?.cardNumber) || '',
    })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleMerchantSet = useCallback(
    async (merchant: MerchantLookupTypes[]) => {
      try {
        purchaseTxMerchantSet(merchant)
        toast.success('Merchant Selected')
      } catch (error) {
        toast.error('Something went wrong.')
      }
    },
    [purchaseTxMerchantSet]
  )

  const handleSubmitCreditAllocationTx = useCallback(
    async (
      values: creditAllocationTxFormSubmitValuesTypes,
      actions: creditAllocationTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        if (String(values.externalTransactionId) === "") {
          values.externalTransactionId = initialValues.externalTransactionId + 1
        }
        const submitValues = {
          ...values,
        }
        await creditAllocationAPI(submitValues)
        toast.success('Credit Allocation successful.')
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearCreditAllocationTx = useCallback(() => {
    initialValuesSet({ ...CREDITALLOCATIONTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleMerchantSet,
    handleSubmitCreditAllocationTx,
    handleClearCreditAllocationTx,
  }
}
